import { locatorServiceAPI } from 'shared/services';

import { PaymentType } from '../types';

export const paymentsAPI = {
  getPaymentTypes: () => locatorServiceAPI.get<PaymentType[]>('payment-types')
};
